define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/heading/Time",
	"csi/types",
	"csi/widget/DateTimeTextBox"
], function(declare,lang,Time,types,DateTimeTextBox) {

	var PAST_ATTRIBUTES = {
		"ModifiedAt": 1,
		"StateChangeTime": 1
	};

	var NO_BLANKS_ATTRIBUTES = {
		"ModifiedAt": 1
	};

	return declare(Time, {
		focusDefault: true,

		getDateRangeParams: function(/*Spec*/spec, /*Object?*/extraParams) {
			// summary: return parameters to use for selecting date range
			var params = this.inherited(arguments);
			var popupParams = params.popupParams;
			var h = spec.heading;
			popupParams.allowTime = true;
			popupParams.inPast = h && PAST_ATTRIBUTES[h.m_id];

			if (popupParams.allowBlanks == null) {
				if (h && !h.m_path && NO_BLANKS_ATTRIBUTES[h.m_id]) {
					popupParams.allowBlanks = false;
				}
			}

			return params;
		},

		toHtmlDynamic: function(/*Context*/ctx, /*Heading*/h, /*DOMNode*/refNode, /*Object*/params) {
			// summary: show composite control - if need custom behavior for disabling values,
			// then pass isDisabledValue(Date) function as param (see DateTextBox)
			this._addDynamicParams(ctx, h, params);

			if (params.timeConstraints == null) {
				params.timeConstraints = this._timeConstraints;
			}

			var dateTimeTextBoxObj = new DateTimeTextBox(params);
			dateTimeTextBoxObj.focusDefault = this.focusDefault;

			return dateTimeTextBoxObj;
		},

		_addDynamicParams: function(/*Context*/ctx, /*Heading*/h, /*Object*/params) {
			// summary: return value for widget
			params.dateParams = params.dateParams || {};
			params.dateParams.constraints = params.dateParams.constraints || this._constraints;
			params.timeParams = params.timeParams || {};
			params.timeParams.constraints = params.timeParams.constraints || this._timeConstraints;
			params.constraints = params.dateParams.constraints;
			
			if (params.value == null) {
				params.value = this._getValue(ctx, h);
			}

			// only allow date picker to select present and future date
			var constraints = params.constraints;
			if (constraints.inPresent) {
				constraints.min = new Date();
			}
		},

		_setConstraints: function(/*String*/format) {
			// summary: setup date and time constraints
			this.inherited(arguments);

			var	c = this._timeConstraints = lang.delegate(types.getTimeFormatOptions(types.FORMAT_TIME));
			if (this.minTime) c.min = this.minTime;
			if (this.maxTime) c.max = this.maxTime;
		}
	});
});